<template>
  <div v-show="textBanners.length > 0">
    <template v-if="$apollo.queries.bannersActive.loading">
      <!--
      <div
        class="d-flex justify-center align-center strong ma-auto w-100"
        style="min-height: 4.2vh;"
      >
        <v-progress-circular active indeterminate color="muted" />
      </div>
      -->
    </template>
    <AppTextBannerCollection v-else :banners="textBanners" />
  </div>
</template>
<script>
import gql from "fraql";
import { sortBy } from "lodash-es";
import { textBanners } from "./bannersActive.js";
import AppTextBannerCollection from "./AppTextBannerCollection.vue";
export default {
  name: "AppShowBannerTexts",
  components: { AppTextBannerCollection },
  props: {
    placementName: {
      type: String,
      required: true
    }
  },
  data() {
    return { bannersActive: [] };
  },
  computed: {
    desktopOrMobileBanners() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return this.bannersActive.filter(b => b.placement.includes("DESKTOP"));
      }
      return this.bannersActive.filter(b => b.placement.includes("MOBILE"));
    },
    textBanners() {
      return sortBy(
        this.desktopOrMobileBanners
          .filter(b => b.contentType.includes("TEXT"))
          .map(b => {
            switch (b.contentType) {
              case "TEXT_ALERT":
                return Object.assign({}, b, {
                  backgroundColor: "alert",
                  icon: "$iconBell",
                  iconColor: "red",
                  role: "alert"
                });
              case "TEXT_INFO":
                return Object.assign({}, b, {
                  backgroundColor: "primary-light",
                  icon: "$iconClipboard",
                  iconColor: "muted",
                  role: "application"
                });
            }
          }),
        "rank"
      );
    }
  },
  apollo: {
    bannersActive: {
      query: gql`
        query bannerTexts{
          bannersActive {
           ${textBanners}
          }
        }
      `,
      fetchPolicy: "cache-first"
    }
  }
};
</script>
<style scoped lang="scss">
.banner-col {
  flex-grow: 0.2;
}
</style>
